import React from 'react';
import './App.css';
import Header from './components/Header';
import HeroSection from './components/HeroSection';
import Features from './components/Features';
import About from './components/About';
import Contact from './components/Contact';
import Footer from './components/Footer';
import Clients from './components/Clients';
import PrivacyPolicy from './components/PrivacyPolicy';

function HomePage() {
  return (
    <>
      <Header />
      <HeroSection />
      <Features />
      <About />
      <Clients />
      <Contact />
      <Footer />
    </>
  );
}

function App() {
  return window.location.pathname === '/politica-de-privacidade' ? <PrivacyPolicy /> : <HomePage />;
}

export default App;
